var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.customization_logo)?_c(_vm.customization_logo_url ? 'a' : 'div',_vm._b({tag:"component",staticClass:"custom-logo"},'component',_vm.customization_logo_url ? { href: _vm.customization_logo_url, target: '_blank' } : {},false),[_c('img',{staticClass:"custom-logo__image",attrs:{"src":_vm.customization_logo,"alt":""}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }